<mat-dialog-content>
  <h1 class="mat-h1">{{ (productsDump$ | async)?.name }}</h1>
  @if (productConfigDump$ | async; as dump) {
    <lib-product-config-parser
    [dump]="{
      config: dump
    }"
      [picked]="pickedConfig"
    ></lib-product-config-parser>
  }

  @if (config.hasPersonalization) {
    <lib-parse-personalization [config]="config"></lib-parse-personalization>
    <img
      [src]="{decorations:[{decorationForClientId:(config | getPersonalizationConfig).decorationId}], personalization:(config | getPersonalizationConfig)} | getDecorationsBg:null | async | sanitizeUrl" />
    }


  </mat-dialog-content>
  <mat-dialog-actions>
    <lib-button mat-dialog-close>Zamknij</lib-button>
    @if (order.configs.length > 1) {
      <div class="pagination">
        <lib-button
      (click)="
        index = index === 0 ? order.configs.length - 1 : index - 1;
        reload$.next(orderId$.value)
      "
          >Poprzedni
        </lib-button>
        <lib-button
      (click)="
        index = index === order.configs.length - 1 ? 0 : index + 1;
        reload$.next(orderId$.value)
      "
          >Następny
        </lib-button>
      </div>
    }
  </mat-dialog-actions>
